const getToken = () => {
  return localStorage.getItem("user");
};

export default getToken;
